import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const Tbl = styled.table`
${({ displayState }) => css`
    width: 100%;
    thead, tbody tr {
      width: 100%;
    }
    
    thead th {
      position: ${displayState?.notSticky ? 'unset' : 'sticky'};
      top: 0;
      z-index: 1;
    }
    
    thead th:first-child {
      position: ${displayState?.notSticky ? 'unset' : 'sticky'};
      left: ${displayState?.notSticky ? 'unset' : 0};
      padding-left: 0px;
      z-index: 2;
    }
    
    tbody th {
      position: sticky;
      left: 0;
      z-index: 1;
    }
  `}
`;

export default Wrapper(Tbl);